<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
      width="35%"
    >
      <v-card>
        <v-card-title class=" subtitle-1 pa-2">
          <v-icon v-text="$getIcon('mdiAccountSwitch')"></v-icon>
          <span class="ml-2">
            {{ displayForm ? "Create Organization" : "Switch Organization" }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!displayForm"
            small
            color="primary"
            @click="displayForm = true"
          >
            Create new
          </v-btn>
          <v-btn icon small @click="$emit('close')">
            <v-icon v-text="$getIcon('mdiClose')"> </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="displayForm" class="pa-1">
          <create-organization-form
            v-if="displayForm"
            v-model="displayForm"
            @close="displayForm = false"
            @create="(displayForm = false), updateOrganizationsList()"
          ></create-organization-form>
        </v-card-text>
        <v-card-text
          v-if="crmUserOrganizations.length && !displayForm"
          class="scrollbar-md"
        >
          <div v-for="(item, i) in crmUserOrganizations" :key="i">
            <v-hover v-slot:default="{ hover }" class="mt-5 mx-6 pointer">
              <v-card
                @click="switchOrganization(item.name, item.slug)"
                :elevation="hover ? 16 : 2"
                outlined
                light
              >
                <v-card-text
                  class="subtitle-1 font-weight-bold"
                  align="center"
                  v-text="item.name"
                ></v-card-text>
              </v-card>
            </v-hover>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getOrSetOrganizationState } from "@/utils/permission";
import CreateOrganizationForm from "@/components/crm/organization/CreateOrganization";
export default {
  components: {
    CreateOrganizationForm
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayForm: false
    };
  },
  computed: {
    crmUserOrganizations() {
      return this.$store.state.shell.switchableOrganizations;
    }
  },
  methods: {
    updateOrganizationsList() {
      const endpoint = `/api/v1/org/`;
      this.$axios.$get(endpoint).then(response => {
        this.$store.commit(
          "shell/SET_SWITCHABLE_ORGANIZATIONS",
          response.results
        );
      });
    },
    switchOrganization(orgName, orgSlug) {
      getOrSetOrganizationState(this.$axios, this.$store.commit, {
        orgName,
        orgSlug
      });
      window.location.reload();
      this.$store.dispatch("shell/showSnackbar", {
        text: `Successfully switched to ${orgName}`,
        color: "green"
      });
      this.$emit("close");
    }
  }
};
</script>
